<ng-container *ngIf="!loading; else showLoading">
    <ng-container *ngIf="readonly; else notReadonly">
        <div class="py-3">
            <div class="card p-4 mx-auto" style="max-width: 480px">
                <div class="text-muted small text-uppercase mb-1">{{ "Platform" | translate }}</div>
                <h5 class="mb-3">{{ selectedPlatform ?? "" | translate }}</h5>
                <div class="text-center">
                    <button type="button" class="btn btn-primary" (click)="confirmReadonly()">
                        {{ "Next" | translate }} <span class="bi ps-2 bi-arrow-right"></span>
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #notReadonly>
        <ng-container *ngIf="authorized === false; else showPickPlatform">
            <div class="py-3 text-center">
                <div class="text-danger fs-4 pb-2 text-center">{{ "You are not authorized to create an offer" | translate }}</div>
                <app-todo-list [todoList]="todoList"></app-todo-list>
                <div class="request-validation-container">
                    <app-validation-status [user]="user" [todoList]="todoList"></app-validation-status>
                </div>
            </div>
        </ng-container>
        <ng-template #showPickPlatform>
            <div class="row align-items-stretch g-4 py-lg-5">
                <div class="col-12 col-lg-4" *ngFor="let card of visiblePlatformCards">
                    <div
                        class="card p-3 h-100 d-flex flex-column justify-content-between align-items-center position-relative"
                        [class.disabled]="!isPlatformEnabled(card.id)"
                        [class.border-primary]="selectedPlatform === card.id"
                    >
                        <div>
                            <h5 class="text-center">{{ card.id | translate }}</h5>
                            <p class="text-center text-muted" [innerHTML]="card.descriptionKey | translate"></p>
                        </div>
                        <div class="text-center mt-3">
                            <button
                                class="btn"
                                [ngClass]="card.buttonClass"
                                [disabled]="!isPlatformEnabled(card.id)"
                                (click)="pickPlatform(card.id)"
                            >
                                {{ card.publishKey | translate }}
                            </button>
                        </div>
                        <div class="disabled-info-text" *ngIf="!isPlatformEnabled(card.id) && !isCompanyAccount">
                            <a class="btn btn-secondary text-white fw-bold" routerLink="/profile">
                                {{ "Upgrade to Pro" | translate }}
                            </a>
                        </div>
                        <div class="disabled-info-text" *ngIf="!isPlatformEnabled(card.id) && isCompanyAccount">
                            <span class="btn btn-secondary text-white fw-bold text-wrap">
                                {{ "Platform not available for company activity" | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ng-template>
</ng-container>
<ng-template #showLoading>
    <div class="py-3 text-center">
        <app-loader></app-loader>
    </div>
</ng-template>
